var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('v-btn',{attrs:{"depressed":""},on:{"click":_vm.exportToCsv}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-upload")]),_vm._v(" "+_vm._s(_vm.$t("app.export"))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }